import templateUrl from "./login.html";
import capitalize from "lodash/capitalize";
import { encryption } from "../../../common/encryption";

export const loginComponent = {
  templateUrl,
  controller: class LoginComponent {
    constructor($state, AuthService, $location, toastr, ApiService) {
      "ngInject";

      this.$state = $state;
      this.authService = AuthService;
      this.toastr = toastr;
      this.apiService = ApiService;
      this.username = "";
      this.password = "";
      this.emailId = "";
      this.$location = $location;
      this.mismatchPswd = false;
    }

    $onInit() {
      this.passwordType = "password";
      this.showPassword = false;
      this.forgotPassword = false;
    }

    onShowPasswordChange() {
      this.passwordType = this.showPassword ? "text" : "password";
    }

    login() {
      // this.$state.go('home');
      const enUsername = encryption(this.username)
      const enPassword = encryption(this.password)

      console.log('username', enUsername);
      console.log('password', enPassword);

      this.authService
        .login(enUsername, enPassword)
        .then(() => {
          const redirect = this.authService.getLoginRedirect();
          if (redirect.length > 0) {
            this.$location.url(redirect);
            this.authService.setLoginRedirect("");
          } else {
            this.$state.go("home");
          }
        })
        .catch((err) => {
          this.errorMsg = capitalize(this.apiService.getErrorMessage(err));
        });
    }

    showForgotPasswordView() {
      this.forgotPassword = true;
    }

    onSubmit() {
      const email = this.emailId;
      this.authService
        .forgotPassword(email)
        .then((details) => {
          this.successSubmit = true;
        })
        .catch((err) => {
          this.toastr.error(err);
        });
    }

    hideForgotPasswordForm() {
      this.forgotPassword = false;
    }

    showLoginForm() {
      this.forgotPassword = false;
      this.successSubmit = false;
      this.emailId = "";
    }

    submitVerifyForm() {
      this.onSubmit();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/auth/login/login.component.js